import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, Input } from '@angular/core';
import { GlobalInfoService } from '@app/core';
import { ConfirmComponent } from '@app/shared';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LocalDataSource } from 'ng2-smart-table';
import { BsModalRef } from 'ngx-bootstrap';
import { UserInstanceProcedureService, systemUserTask } from './shared/users-instance-procedure.service';
import { UserInstanceProcedureFormService } from './shared/users-instance-procedure.forms.service';
import { UserInstanceProcedureConfig } from './shared/users-instance-procedure.config.service';
import { findIndex, remove, find } from 'lodash';
import { NgSelectComponent } from '@ng-select/ng-select';


@Component({
  selector: 'iw-users-instance-procedure',
  templateUrl: './users-instance-procedure.component.html',
  styleUrls: ['./users-instance-procedure.component.scss'],
  providers: [
    UserInstanceProcedureService,
    UserInstanceProcedureFormService
  ]
})  
export class UserInstanceProcedureComponent implements OnInit {
  // Usuarios del sistema 
  systemUsers: any = [];
  structureUsers: any = [];
  // Configuración de las tablas
  settingTableUsers = {};
  settings = {};
  settingTableUsersReasign = {};
  // Define cuando se esta cargando los tramites en las tabla
  isLoading = false;
  // Define cuando se esta cargando los usuarios
  isLoadingPincipal = false;
  // Define cuando se esta ejecutando el reemplazo de usuarios
  isLoadingReplace = false;
  // Datos de la tabla
  data: any[] = [];
  //Actividades de la petición
  activities: systemUserTask[];
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  sourceUsers: LocalDataSource;
  sourceAsignations: LocalDataSource;
  // Referencia de la modal
  modalRef: BsModalRef;
  // validación para el botón asignar
  asignButton: boolean = false;
  // validación para el botón borrar
  replaceButton: boolean = false;
  // informacion del calendario
  calendarData: any[] = [];
  //Tareas seleccionadas
  selectedTask: any[] = [];
  selectedRows: any = [];
  //Usuario seleccionado en el control
  userSelected: any;
  //Usuario seleccionado en el control
  userReplaceSelected: any;
  //usuario a reasignar o usuario a asignar
  userToAsign: any[] = [];
  // cadena de mensaje de confirmación
  question = '';
  // Valida si se asigna el responsable o se reemplaza
  replace: boolean = false;
  // Referencia al template de la modal de duplicacion de forma
  @ViewChild('modalPersonalized') private modalPersonalized: TemplateRef<any>;
  // Referencia al template de la modal de duplicacion de forma
  @ViewChild('modalTable') private modalTable: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmReasign') private confirmFinish: ConfirmComponent;
  // Referencia al selector
  @ViewChild('ngSelectComponent') private ngSelectComponent: NgSelectComponent;
  // Indica el cierre del componente de asignaciones
  @Output() closeAssignment = new EventEmitter<boolean>();

  constructor(
    private cs: UserInstanceProcedureService,
    private gis: GlobalInfoService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.isLoadingPincipal = true;
    const configTable = new UserInstanceProcedureConfig();
    // Obtiene los usuarios del sistema
    this.cs.getSystemUsers().then(async res=>{
      this.systemUsers =  await res.valores;
      this.structureUsers = await res.estructura;
      this.settingTableUsers = configTable.getSettingsUserTable();
      await this.structureUsers.forEach((s: { alias: string | number; nombre: any; orden: any; }) => {
        this.settingTableUsers['columns'][s.alias] = {
          editable: false,
          title: s.nombre,
          orden: s.orden,
          filter: {
            inputClass: 'form-control',
          }
        };
      });
      this.sourceUsers = new LocalDataSource()
      this.systemUsers.forEach((user: any) => {
          this.sourceUsers.append(user);
      });
      this.isLoadingPincipal = false;
    });
    // Actualizar título de la vista
    this.gis.set({ title: 'Reemplazar Usuarios en tramites' });
    this.settings = configTable.getSettingsTable();
  }

  //Cambio en el selector
  selectedUser(user: any){
    this.asignButton = false;
    this.replaceButton = false;
    this.data.length = 0;
    this.isLoading=true;
    this.userSelected = user.data;
    this.cs.getDataCalendar(this.userSelected.id).then(async res=>{
      this.calendarData =  await res.valores;
      res.estructura.forEach((s: { alias: string | number; nombre: any; orden: any; }) => {
        this.settings['columns'][s.alias] = {
          editable: false,
          title: s.nombre,
          orden: s.orden,
          filter: {
            inputClass: 'form-control',
          }
        };
      });
      this.data = [];
      if (this.calendarData && this.calendarData.length) {
        this.calendarData.forEach((activity, i) => {
          activity.select = false;
          const d = {};
          Object.keys(activity).forEach(key => {
            if (key !== 'campos') {
              d[key] = activity[key];
            }
          });
          this.data.push(d);
        });
      }
      this.isLoading=false;
      this.sourceData = new LocalDataSource(this.data);
      this.sourceData.refresh();
    });
    this.modalRef = this.modalService.show(this.modalTable, { class: 'modal-lg', backdrop: 'static' });
  }

  /**
   * Controla el evento clic en la fila de la tabla.
   *
   * @param {any} row
   * @memberof UserInstanceProcedureComponent
   */
  onCellClick(row: any) {
    this.selectedRows = row.selected;
    // const userIndex = findIndex(this.data, {id: row.data.id});

    // const removed = remove(this.selectedTask, u => {
    //   return u.id === row.data.id;
    // });
    // if(!removed.length){
    //   if (userIndex !== -1) {
    //     this.data[userIndex]['select'] = true;
    //     this.selectedTask.push(row.data);
    //     this.sourceData.refresh();
    //   }
    // }else{
    //   if (userIndex !== -1) {
    //     this.data[userIndex]['select'] = false;
    //     this.sourceData.refresh();
    //   }
    // }
  }

  
  /**
   * Abre el modal con el formulario
   *
   * @memberof UserInstanceProcedureComponent
   */
  openModalReasign() {
    let configTable = new UserInstanceProcedureConfig();
    this.settingTableUsersReasign = configTable.getSettingsTableUserReplace();
    this.structureUsers.forEach((s: { alias: string | number; nombre: any; orden: any; }) => {
      this.settingTableUsersReasign['columns'][s.alias] = {
        editable: false,
        title: s.nombre,
        orden: s.orden,
        filter: {
          inputClass: 'form-control',
        }
      };
    });
    this.sourceAsignations = new LocalDataSource()
    this.systemUsers.forEach((user: any) => {
      user['first_name'] = user.nombres;
      user['last_name'] = user.apellidos;
      if(user.id !== this.userSelected.id){
        user['select'] = false;
        this.sourceAsignations.append(user);
      }
    });
    this.modalRef.hide();
    this.modalRef = this.modalService.show(this.modalPersonalized, { class: 'modal-lg', backdrop: 'static' });
  }

  /**
   * Controla cuando el usuario hace click en la tabla de la modal
   *
   * @memberof UserInstanceProcedureComponent
   */
  clickUser(user: any){
    const userIndex = findIndex(this.systemUsers, {id: user.data.id});
    if (userIndex !== -1) {
      this.userReplaceSelected = find(this.systemUsers,{id:user.data.id});
      this.replaceButton = true;
    }else{
      this.userReplaceSelected = null;
      this.replaceButton = false;
    }
  }

  /**
   * Validad el reemplazamiento
   *
   * @memberof UserInstanceProcedureComponent
   */
  replaceConfirm(){
    if(this.userReplaceSelected){
      this.question = '¿Está seguro que desea reemplazar el usuario: '+ (this.userSelected.identificacion ? this.userSelected.identificacion : "")+" - "+ (this.userSelected.nombres? this.userSelected.nombres : "") +" "+(this.userSelected.apellidos? this.userSelected.apellidos: "")+'?'
      this.replace = true;
      this.confirmFinish.open();
    }
  }

  /**
   * Evento que finaliza la reasignación.
   *
   * @memberof UserInstanceProcedureComponent
   */
  finish(confirmation?: boolean) {
    if (confirmation) {
      this.isLoadingReplace = true;
      this.cs.replaceUser(this.userSelected.id, this.selectedRows, this.userReplaceSelected.id)
      .then((result)=>{
          this.isLoadingReplace = false;
          this.asignButton = false;
          this.replaceButton = false;
          this.modalRef.hide();
          this.data.length = 0;
          this.sourceData.reset();
          // this.selectedTask.length = 0;
          // this.selectedTask = [];
          this.sourceAsignations.reset();
          this.userReplaceSelected = null;
          this.selectedRows = [];
          this.selectedRows.length = 0;
      },
      (error)=>{
        this.isLoadingReplace = false;
      })
    }
  }

  /**
   * Oculta el modal y carga de nuevo la tabla
   *
   * @private
   * @memberof UserInstanceProcedureComponent
   */
  hideModal(){
    this.asignButton = false;
    this.replaceButton = false;
    this.sourceData.reset();
    // this.selectedTask.length = 0;
    // this.selectedTask = [];
    this.selectedRows = [];
    this.selectedRows.length = 0;
    this.modalRef.hide();
  }

   /**
   * Oculta el modal y carga de nuevo la tabla
   *
   * @private
   * @memberof UserInstanceProcedureComponent
   */
    hideModalReplace(){
      this.asignButton = false;
      this.replaceButton = false;
      this.sourceAsignations.reset();
      this.userReplaceSelected = null;
      // this.selectedTask.length = 0;
      // this.selectedTask = [];
      this.selectedRows = [];
      this.selectedRows.length = 0;
      this.modalRef.hide();
      this.ReloadTableUserProcedure();
    }

  /**
   * Limpia el selector
   *
   * @private
   * @memberof UserInstanceProcedureComponent
   */
  clearSelect(){
    this.ngSelectComponent.clearModel();
  }

 /**
   * permite recargar el modal de consulta de tramites para el usuario seleccionado
   *
   * @private
   * @memberof UserInstanceProcedureComponent
   */
  ReloadTableUserProcedure(){
    this.asignButton = false;
    this.replaceButton = false;
    this.data.length = 0;
    this.isLoading=true;
    this.cs.getDataCalendar(this.userSelected.id).then(async res=>{
      this.calendarData =  await res.valores;
      res.estructura.forEach((s: { alias: string | number; nombre: any; orden: any; }) => {
        this.settings['columns'][s.alias] = {
          editable: false,
          title: s.nombre,
          orden: s.orden,
          filter: {
            inputClass: 'form-control',
          }
        };
      });
      this.data = [];
      if (this.calendarData && this.calendarData.length) {
        this.calendarData.forEach((activity, i) => {
          activity.select = false;
          const d = {};
          Object.keys(activity).forEach(key => {
            if (key !== 'campos') {
              d[key] = activity[key];
            }
          });
          this.data.push(d);
        });
      }
      this.isLoading=false;
      this.sourceData = new LocalDataSource(this.data);
      this.sourceData.refresh();
    });
    this.modalRef = this.modalService.show(this.modalTable, { class: 'modal-lg', backdrop: 'static' });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/users-instance-procedure/users-instance-procedure.component.ts